import LandingNav from "../components/landing/LandingNav";
import LandingHero from "../components/landing/LandingHero";
import LandingFeatures from "../components/landing/LandingFeatures";
import { Link } from "react-router-dom";

/**
 * HomePage — Combava primary sales homepage implementing the Figma design.
 */
export default function HomePage() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col selection:bg-[#15DE9B] selection:text-black">
      {/* ═══ Hero Shell (extends up behind global navbar, content inline) ═══ */}
      <div className="w-full max-w-[1255px] mx-auto px-4 sm:px-6 md:px-8">
        <div className="w-full rounded-b-[20px] md:rounded-b-[24px] relative shadow-2xl bg-hero-gradient">
          {/* Navigation */}
          <LandingNav />

          {/* Hero Content (inline with navigation) */}
          <LandingHero />
        </div>
      </div>

      {/* ═══ Main Sales Content ═══ */}
      <main className="flex-1 flex flex-col">
        <LandingFeatures />
      </main>

      {/* ═══ Footer ═══ */}
      <footer className="w-full border-t border-white/10 bg-[#08080a] py-12">
        <div className="w-full max-w-[1255px] mx-auto px-4 sm:px-6 md:px-8 flex flex-col sm:flex-row items-center justify-between gap-6 text-xs text-gray-500">
          <div className="flex items-center gap-2">
            <span className="text-white font-bold tracking-wider">COMBAVA</span>
            <span>&copy; {new Date().getFullYear()} Combava Research. All rights reserved.</span>
          </div>

          <div className="flex items-center gap-6">
            <Link to="/charts" className="hover:text-gray-300 no-underline text-gray-500 transition-colors">
              Charts
            </Link>
            <Link to="/terminal" className="hover:text-gray-300 no-underline text-gray-500 transition-colors">
              Terminal
            </Link>
            <a
              href="https://www.sec.gov/edgar"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 no-underline text-gray-500 transition-colors"
            >
              SEC EDGAR
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
